<template>
  <ul class="tracking-status d-flex justify-content-between">
    <template v-for="event in pipelineDefault" :key="`pipeline-item-${event.name}`">
      <li :class="{ active: event.active }">
        {{ capitalizeFirstLetter(event.name) }}
      </li>
    </template>
  </ul>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { DELIVERED, EXCEPTION, IN_TRANSIT, OUT_FOR_DELIVERY, RETURNED } from '@/consts/TrackingEventStatuses'
import { capitalizeFirstLetter } from '@/helpers/Utils'

export default defineComponent({
  name: 'TrackingStepper',
  props: {
    status: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const { t } = useI18n()

    const pipelineDefault = computed(() => {
      return {
        INFO_RECEIVED: {
          name: t('steps.booked'),
          active: true,
        },
        IN_TRANSIT: {
          name: t('steps.in_transit'),
          active: [IN_TRANSIT, OUT_FOR_DELIVERY, DELIVERED, EXCEPTION, RETURNED].includes(props.status),
        },
        OUT_FOR_DELIVERY: {
          name: t('steps.out_for_delivery'),
          active: [OUT_FOR_DELIVERY, DELIVERED, RETURNED].includes(props.status),
        },
        DELIVERED: {
          name: t('steps.delivered'),
          active: [DELIVERED, RETURNED].includes(props.status),
        },
      }
    })

    return {
      pipelineDefault,
      capitalizeFirstLetter,
    }
  },
})
</script>
